import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { passwordRules } from '../core/domain/password-policy';

/**
 * Critères de mot de passe, cochés au fil de la saisie.
 *
 * `aria-live="polite"` fait annoncer les critères satisfaits par un lecteur
 * d'écran sans interrompre la frappe. Sans cela, la liste serait une information
 * purement visuelle et la contrainte resterait invisible à qui n'y voit pas.
 *
 * Les pastilles portent un texte alternatif : la couleur seule ne peut pas
 * distinguer un critère rempli d'un critère manquant.
 */
@Component({
  selector: 'ct-password-rules',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ul aria-live="polite">
      @for (rule of rules(); track rule.label) {
        <li [class.met]="rule.met">
          <span aria-hidden="true">{{ rule.met ? '✓' : '·' }}</span>
          <span class="ct-sr-only">{{
            rule.met ? 'critère rempli :' : 'critère à remplir :'
          }}</span>
          {{ rule.label }}
        </li>
      }
    </ul>
  `,
  styles: `
    ul {
      display: flex;
      flex-wrap: wrap;
      gap: var(--ct-space-1) var(--ct-space-4);
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: var(--ct-size-xs);
      color: var(--ct-text-muted);
    }

    li {
      display: flex;
      align-items: center;
      gap: var(--ct-space-1);
    }

    .met {
      color: var(--ct-vert-cageot);
      font-weight: var(--ct-weight-medium);
    }
  `,
})
export class CtPasswordRules {
  readonly value = input('');

  protected readonly rules = computed(() => passwordRules(this.value()));
}
